import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import styles from './ApproveBillingAgreementDialog.styles.scss';
import cn from 'classnames';
import i18n from '../../../../config/i18n';
import { useNavigate } from 'react-router';
import { AGREEMENT_TYPE } from '../../config/constants';

const ApproveBillingAgreementDialog = ({
  showDialog,
  setShowDialog,
  onConfirm,
  isAmendment,
  agreementType,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [showSuccess, setShowSuccess] = useState(false);

  return (
    <Dialog
      onHide={() => setShowDialog(false)}
      className={cn(
        'rounded-4 overflow-hidden',
        styles.approveBillingAgreementDialog,
      )}
      visible={!!showDialog}
      footer={
        <>
          <Divider className="mb-4" />
          {showSuccess ? (
            <div className={styles.formActions}>
              <Button
                className={styles.formBtn}
                label={t('common.home')}
                onClick={() => {
                  setShowDialog(false);
                  navigate(
                    `/${i18n.language}/additional-functionalities/special-billing`,
                  );
                }}
              />
            </div>
          ) : (
            <div className={styles.formActions}>
              <Button
                className={styles.formBtn}
                label={t('common.cancel')}
                onClick={() => {
                  setShowDialog(false);
                }}
              />
              <Button
                className={styles.formBtn}
                label={t('common.confirm')}
                onClick={() => {
                  onConfirm().then(() => {
                    setShowSuccess(true);
                  });
                }}
              />
            </div>
          )}
        </>
      }
    >
      <div className={styles.submissionMessage}>
        <span>
          <div>
            <i className="pi pi-file-check" />
          </div>
        </span>
        {showSuccess && (
          <>
            <p>
              {isAmendment
                ? agreementType == AGREEMENT_TYPE.SELF
                  ? t('special_billing.amendment-approved_desc')
                  : t('special_billing.amendment-approved_third_party_desc')
                : agreementType == AGREEMENT_TYPE.SELF
                ? t('special_billing.agreement-approved_desc')
                : t('special_billing.agreement-approved_third_party_desc')}
            </p>
          </>
        )}
        {!showSuccess && (
          <>
            <h3>
              {isAmendment
                ? t('special_billing.approve-amendment')
                : t('special_billing.approve-agreement')}
            </h3>
            <p>
              {isAmendment
                ? t('special_billing.approve-amendment_desc')
                : t('special_billing.approve-agreement_desc')}
            </p>
          </>
        )}
      </div>
    </Dialog>
  );
};

export default ApproveBillingAgreementDialog;
